@if (loading && cards.length === 0) {
<section class="dashboard-home__cards" aria-label="Loading dashboard metrics">
  @for (card of getSkeletonCards(); track card) {
  <article class="dashboard-card dashboard-card--skeleton">
    <div class="dashboard-card__skeleton-line dashboard-card__skeleton-line--title"></div>
    <div class="dashboard-card__skeleton-line dashboard-card__skeleton-line--value"></div>
    <div class="dashboard-card__skeleton-line dashboard-card__skeleton-line--trend"></div>
  </article>
  }
</section>
} @else {
<section class="dashboard-home__cards" aria-label="Dashboard metrics">
  @for (card of cards; track card.key) {
  <article
    class="dashboard-card"
    [class.dashboard-card--up]="card.direction === 'up'"
    [class.dashboard-card--down]="card.direction === 'down'"
    [class.dashboard-card--flat]="card.direction === 'flat'">
    <div class="dashboard-card__content">
      <h2 class="dashboard-card__title">{{ card.title }}</h2>
      <strong class="dashboard-card__value">{{ formatValue(card.value) }}</strong>

      <div class="dashboard-card__trend">
        <span class="dashboard-card__trend-icon">
          <ng-glyph [name]="getTrendIcon(card)" size="18"></ng-glyph>
        </span>
        <span class="dashboard-card__trend-value">{{ formatPercentage(card.percentageChange) }}</span>
        <span class="dashboard-card__trend-label">{{ selectedPeriodLabel }}</span>
      </div>
    </div>

    <div class="dashboard-card__sparkline" aria-hidden="true">
      @for (bar of card.sparkline; track $index) {
      <span class="dashboard-card__bar" [style.height.px]="getSparklineHeight(card, bar)"></span>
      }
    </div>
  </article>
  }
</section>
}
